/* Rescuevation – Soot-X-Produktseite (rescu-sx-*), 05.10.2026.

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse sx-go, nach animationend
   wieder entfernt) und startet Schleifen nur, solange sie zu sehen sind.

   Kaufen: Kaufbereich, Set-Kacheln und Routine legen ihre Artikel in einem Aufruf
   in den Warenkorb (/cart/add.js mit items) und öffnen danach Dawns Schublade;
   ohne Schublade geht es auf die Warenkorbseite. */
(function () {
  'use strict';
  if (window.__rsx) return;
  window.__rsx = true;

  var doc = document.documentElement;
  doc.classList.add('sx-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };

  /* ---------- Geld ---------- */

  var zahlFormat = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(cent) { return zahlFormat.format(Math.round(cent) / 100) + ' €'; }
  function brutto(cent) { return Math.round(cent * 1.19); }

  /* ---------- Einblenden ---------- */

  function einmal(el) {
    if (el.__sxLief) return;
    el.__sxLief = true;
    el.classList.add('sx-go');
    var fertig = false;
    var ende = function (e) {
      if (fertig) return;
      if (e && e.target !== el) return;
      fertig = true;
      el.classList.remove('sx-go');
      el.removeEventListener('animationend', ende);
    };
    el.addEventListener('animationend', ende);
    setTimeout(function () { ende(); }, 2600);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      if (!el.style.getPropertyValue('--sx-d')) {
        var d = el.hasAttribute('data-sx-d') ? parseInt(el.getAttribute('data-sx-d'), 10) : n * 90;
        el.style.setProperty('--sx-d', Math.min(d, 600) + 'ms');
      }
      gruppen.set(g, n + 1);
    });
  }

  function einblenden(wurzel) {
    if (ruhig || !hatIO) return;
    var els = alle(wurzel, '[data-sx-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      if (el.hasAttribute('data-sx-sofort')) { einmal(el); return; }
      var r = el.getBoundingClientRect();
      /* Was beim Laden schon im Bild steht, bleibt ruhig */
      if (r.top < vh() - 40 && r.bottom > 0) return;
      io.observe(el);
    });
    /* Linie der Anwendungsschritte zeichnet sich einmal */
    alle(wurzel, '[data-sx-linie]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh() - 40 && r.bottom > 0) return;
      var io2 = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io2.disconnect();
        einmal(el);
      }, { rootMargin: '0px 0px -15% 0px' });
      io2.observe(el);
    });
    /* Bühne im Kaufbereich: Flasche und Tube setzen einmal ein */
    alle(wurzel, '.sx-galerie__bild--szene').forEach(function (el) { einmal(el); });
  }

  /* ---------- Schleifen nur, solange sichtbar ---------- */

  function schleifen(wurzel) {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('sx-spielt', e.isIntersecting); });
    }, { threshold: 0.15 });
    alle(wurzel, '[data-sx-spiel]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehlen(wurzel) {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var ziel = parseFloat(String(el.getAttribute('data-sx-zahl')).replace(',', '.'));
        if (isNaN(ziel) || ziel <= 0) return;
        var endText = el.textContent;
        var t0 = null;
        var schritt = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1500);
          var w = 1 - Math.pow(1 - p, 4);
          el.textContent = endText.replace(/[0-9]+/, String(Math.round(ziel * w)));
          if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
        };
        requestAnimationFrame(schritt);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alle(wurzel, '[data-sx-zahl]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(daten);
      } else {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__sxLabel) btn.__sxLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Wird hinzugefügt …';
    } else {
      btn.disabled = false;
      if (btn.__sxLabel) btn.innerHTML = btn.__sxLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__sxLabel || btn.innerHTML;
    btn.disabled = false;
    btn.classList.add('ist-ok');
    btn.innerHTML = '<svg class="sx-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg><span>Im Warenkorb</span>';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function fehler(bereich, text) {
    var f = bereich && bereich.querySelector('[data-sx-fehler]');
    if (!f) return;
    if (!text) { f.hidden = true; f.textContent = ''; return; }
    f.hidden = false;
    f.textContent = text;
  }

  /* ---------- Stepper ---------- */

  function stepper(wurzel) {
    alle(wurzel, '[data-sx-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '999', 10);
        n = Math.max(min, Math.min(max, n || min));
        feld.value = n;
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      };
      st.querySelector('[data-sx-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-sx-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('blur', function () { setzen(parseInt(feld.value, 10)); });
    });
  }

  /* ---------- Galerie ---------- */

  function galerie(wurzel) {
    alle(wurzel, '[data-sx-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-sx-band]');
      var minis = alle(g, '[data-sx-mini]');
      if (!band || !minis.length) return;
      var bilder = alle(band, '.sx-galerie__bild');
      var aktiv = function (i) { minis.forEach(function (m, k) { m.setAttribute('aria-current', k === i ? 'true' : 'false'); }); };
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () {
          var ziel = bilder[i];
          if (!ziel) return;
          band.scrollTo({ left: ziel.offsetLeft - band.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
          aktiv(i);
        });
      });
      var geplant = false;
      band.addEventListener('scroll', function () {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(function () {
          geplant = false;
          var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
          aktiv(Math.max(0, Math.min(minis.length - 1, i)));
        });
      }, { passive: true });
    });
  }

  /* ---------- Kaufbereich ---------- */

  var kaufForm = null;

  function kauf(wurzel) {
    alle(wurzel, '[data-sx-kauf]').forEach(function (bereich) {
      var form = bereich.querySelector('[data-sx-form]');
      if (!form) return;
      kaufForm = form;
      var modus = bereich.getAttribute('data-preis-modus') || 'netto';
      var preisEl = bereich.querySelector('[data-sx-preis]');
      var zweitEl = bereich.querySelector('[data-sx-preis-zweit]');
      var summeEl = bereich.querySelector('[data-sx-summe]');
      var btn = form.querySelector('[data-sx-submit]');
      var anzahl = form.querySelector('[data-sx-anzahl]');
      var radios = alle(form, '[data-sx-variante]');
      var addons = alle(form, '[data-sx-addon]');

      var gewaehlt = function () { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; };

      function rechnen() {
        var r = gewaehlt();
        if (!r) return;
        var p = parseInt(r.getAttribute('data-preis'), 10);
        var n = Math.max(1, parseInt(anzahl.value, 10) || 1);
        var haupt = modus === 'brutto' ? brutto(p) : p;
        var zweit = modus === 'brutto' ? p : brutto(p);
        if (preisEl && preisEl.textContent !== euro(haupt)) {
          preisEl.textContent = euro(haupt);
          if (!ruhig) { preisEl.classList.remove('sx-puls'); void preisEl.offsetWidth; preisEl.classList.add('sx-puls'); }
        }
        if (zweitEl) zweitEl.textContent = euro(zweit);
        var verfuegbar = r.getAttribute('data-verfuegbar') === 'true';
        if (btn) btn.disabled = !verfuegbar;

        var extra = 0, namen = [];
        addons.forEach(function (a) {
          if (a.checked) { extra += parseInt(a.getAttribute('data-preis'), 10); namen.push(a.getAttribute('data-titel')); }
        });
        if (summeEl) {
          if (extra > 0 || n > 1) {
            var netto = p * n + extra;
            summeEl.hidden = false;
            summeEl.innerHTML = 'Summe' + (namen.length ? ' mit ' + namen.join(' und ') : '') + ': <strong>' + euro(modus === 'brutto' ? brutto(netto) : netto) + '</strong> ' +
              (modus === 'brutto' ? 'inkl. MwSt. · ' + euro(netto) + ' netto' : 'netto · ' + euro(brutto(netto)) + ' inkl. MwSt.');
          } else {
            summeEl.hidden = true;
          }
        }
        /* Kaufleiste mitziehen */
        alle(document, '[data-sx-sticky-titel]').forEach(function (t) { t.textContent = 'Soot-X ' + r.getAttribute('data-titel'); });
        alle(document, '[data-sx-sticky-preis]').forEach(function (t) { t.textContent = euro(p); });
      }

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          rechnen();
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', r.value);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* egal */ }
        });
      });
      addons.forEach(function (a) { a.addEventListener('change', rechnen); });
      anzahl.addEventListener('change', rechnen);
      anzahl.addEventListener('input', rechnen);
      rechnen();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = gewaehlt();
        if (!r) return;
        var items = [{ id: parseInt(r.value, 10), quantity: Math.max(1, parseInt(anzahl.value, 10) || 1) }];
        addons.forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
        fehler(bereich, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(items).then(function () {
          knopfOk(btn);
        }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(bereich, 'Das hat nicht geklappt: ' + err.message + '. Bitte versuche es noch einmal oder ruf uns an.');
        });
      });
    });
  }

  /* ---------- Sets ---------- */

  function sets(wurzel) {
    alle(wurzel, '[data-sx-set]').forEach(function (bereich) {
      var modus = bereich.getAttribute('data-preis-modus') || 'netto';

      /* Routine-Knöpfe und "alles" */
      alle(bereich, '[data-sx-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var liste;
          try { liste = JSON.parse(btn.getAttribute('data-sx-add')); } catch (e) { return; }
          var items = liste.map(function (x) { return { id: x.id, quantity: x.q || 1 }; });
          if (!items.length) return;
          var kasten = btn.closest('.sx-routine__alles') || bereich;
          fehler(kasten, '');
          knopfLaeuft(btn, true);
          inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function (err) {
            knopfLaeuft(btn, false);
            fehler(kasten, 'Das hat nicht geklappt: ' + err.message + '.');
          });
        });
      });

      var form = bereich.querySelector('[data-sx-set-form]');
      if (!form) return;
      var wahl = alle(bereich, '[data-sx-set-wahl]');
      var liste = form.querySelector('[data-sx-set-liste]');
      var haupt = form.querySelector('[data-sx-set-haupt]');
      var neben = form.querySelector('[data-sx-set-neben]');
      var anzahl = form.querySelector('[data-sx-set-anzahl]');
      var btn = form.querySelector('[data-sx-set-submit]');
      var aktuelle = [];

      function lesen(radio) {
        var s = radio.closest('label').querySelector('[data-sx-set-items]');
        try { return JSON.parse(s.textContent); } catch (e) { return []; }
      }

      function zeigen(ticken) {
        var r = wahl.filter(function (x) { return x.checked; })[0] || wahl[0];
        if (!r) return;
        aktuelle = lesen(r);
        var n = Math.max(1, parseInt(anzahl.value, 10) || 1);
        var summe = 0;
        liste.innerHTML = '';
        aktuelle.forEach(function (it, i) {
          summe += it.p * it.q * n;
          var li = document.createElement('li');
          li.innerHTML = '<input type="hidden" name="items[' + i + '][id]" value="' + it.id + '">' +
            '<input type="hidden" name="items[' + i + '][quantity]" value="' + (it.q * n) + '">' +
            (it.b ? '<img src="' + it.b + '" alt="" width="40" height="40" loading="lazy">' : '') +
            '<span></span>';
          li.querySelector('span').textContent = (it.q * n) + '× ' + it.t;
          liste.appendChild(li);
        });
        haupt.textContent = euro(modus === 'brutto' ? brutto(summe) : summe);
        neben.textContent = modus === 'brutto' ? euro(summe) + ' netto' : 'netto · ' + euro(brutto(summe)) + ' inkl. MwSt.';
        if (ticken && !ruhig) { haupt.classList.remove('sx-puls'); void haupt.offsetWidth; haupt.classList.add('sx-puls'); }
      }

      wahl.forEach(function (r) { r.addEventListener('change', function () { zeigen(true); }); });
      /* Mobil als Wischreihe: die vorgewählte Kachel ins Bild holen, ohne die Seite zu bewegen */
      var reihe = bereich.querySelector('.sx-set__wahl');
      var gewaehlt = wahl.filter(function (x) { return x.checked; })[0];
      if (reihe && gewaehlt && reihe.scrollWidth > reihe.clientWidth + 4) {
        var karte = gewaehlt.closest('.sx-setkarte');
        reihe.scrollLeft = Math.max(0, karte.offsetLeft - reihe.offsetLeft - parseFloat(getComputedStyle(reihe).paddingLeft || 0));
      }
      anzahl.addEventListener('change', function () { zeigen(true); });
      anzahl.addEventListener('input', function () { zeigen(false); });
      zeigen(false);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = Math.max(1, parseInt(anzahl.value, 10) || 1);
        var items = aktuelle.map(function (it) { return { id: it.id, quantity: it.q * n }; });
        if (!items.length) return;
        fehler(form, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(form, 'Das hat nicht geklappt: ' + err.message + '.');
        });
      });
    });
  }

  /* ---------- Kette: ohne / mit ---------- */

  function kette(wurzel) {
    alle(wurzel, '[data-sx-kette]').forEach(function (k) {
      var knoepfe = alle(k, '[data-sx-zustand]');
      knoepfe.forEach(function (b) {
        b.addEventListener('click', function () {
          var z = b.getAttribute('data-sx-zustand');
          k.setAttribute('data-zustand', z);
          knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- Kaufleiste ---------- */

  function leiste() {
    var st = document.querySelector('[data-sx-sticky]');
    if (!st || !hatIO) return;
    var kaufBereich = document.querySelector('[data-sx-kauf]');
    var kaufKnopf = kaufBereich && (kaufBereich.querySelector('[data-sx-form]') || kaufBereich.querySelector('[data-sx-submit]'));
    var kontakt = document.getElementById('ContactForm') || document.querySelector('.contact');
    var setForm = document.querySelector('[data-sx-set-form]');
    var kaufSichtbar = false, kontaktSichtbar = false, setSichtbar = false, fussSichtbar = false;
    var tief = false;

    function pruefen() {
      var zeigen = tief && !kaufSichtbar && !kontaktSichtbar && !setSichtbar && !fussSichtbar;
      if (zeigen) {
        if (st.hidden) { st.hidden = false; st.classList.add('ist-weg'); requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); }); }); }
        else st.classList.remove('ist-weg');
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
      }
    }
    if (kaufKnopf) new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; pruefen(); }).observe(kaufKnopf);
    if (kontakt) new IntersectionObserver(function (e) { kontaktSichtbar = e[0].isIntersecting; pruefen(); }, { rootMargin: '0px 0px 0px 0px' }).observe(kontakt);
    if (setForm) new IntersectionObserver(function (e) { setSichtbar = e[0].isIntersecting; pruefen(); }).observe(setForm);
    var fuss = document.querySelector('footer, .footer');
    if (fuss) new IntersectionObserver(function (e) { fussSichtbar = e[0].isIntersecting; pruefen(); }).observe(fuss);
    window.addEventListener('scroll', function () {
      var t = window.scrollY > 520;
      if (t !== tief) { tief = t; pruefen(); }
    }, { passive: true });

    var knopf = st.querySelector('[data-sx-sticky-kauf]');
    if (knopf && kaufForm) {
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var label = knopf.innerHTML;
        knopf.innerHTML = 'Wird hinzugefügt …';
        var radios = alle(kaufForm, '[data-sx-variante]');
        var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
        var n = kaufForm.querySelector('[data-sx-anzahl]');
        var items = [{ id: parseInt(r.value, 10), quantity: Math.max(1, parseInt(n && n.value, 10) || 1) }];
        alle(kaufForm, '[data-sx-addon]').forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
        inDenWarenkorb(items).then(function () {
          knopf.innerHTML = '<span>Im Warenkorb</span>';
          setTimeout(function () { knopf.innerHTML = label; }, 2400);
        }).catch(function () {
          knopf.innerHTML = label;
          var ziel = document.getElementById('kaufen');
          if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
        });
      });
    }
  }

  /* ---------- Start ---------- */

  function start() {
    var wurzel = document;
    stepper(wurzel);
    galerie(wurzel);
    kauf(wurzel);
    sets(wurzel);
    kette(wurzel);
    einblenden(wurzel);
    schleifen(wurzel);
    zaehlen(wurzel);
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
